export const apiResources = {
  signIn: `api/auth/login`,
  signOut: `api/auth/logout`,
  forgotPassword: `api/auth/recovery-password`,
  registration: `api/auth/invitation-check-in`,
  profile: `api/auth/profile`,
  companies: `/api/companies`,
  attachmentsAvatars: '/api/attachments',
  attachments: '/api/attachments/company-logo',
  users: '/api/users',
  batch: '/api/users/batch-create',
  trainingInvite: '/api/trainings',
  sessions: '/api/trainings',
  settings: 'api/setting-mains',
  documents: 'api/setting-documents',
  sessionTeams: '/api/training-teams',
  templates: '/api/email-templates',
  reports: 'api/reports/usage-summary',
  reportsCreateSession: 'api/reports/training-overview',
  reportsCreateAssessment: 'api/reports/assessment-overview',
  avatars: 'api/company-avatars',
  sessionAvatars: 'api/company-avatars/company/{companyId}/avatars',
  scenario: 'api/training-sessions',
  scenarioItems: 'api/training-session-items',
  scenarioItemAnswer: 'api/training-session-item-answers',
  urlImage: 'api/attachments/session-item-image',
  urlVideo: 'api/attachments/session-item-video',
  urlAudio: 'api/attachments/session-item-audio',
  urlPdf: 'api/attachments/session-item-pdf',
  urlGoogleEarth: 'api/attachments/session-item-google-earth',
  trainingReferences: 'api/training-references',
  companyLogos: 'api/company-logos',
  notes: 'api/training-user-notes',
  logs: 'api/training-incident-user-comments',
  messages: 'api/training-chat-messages',
  postMessage: 'api/training-user-chats',
  referencesReorder: 'api/training-references/reorder',
  messageAttachment: '/api/attachments/message-attachment',
  sourceMessage: '/api/source-messages',
  infoHub: '/api/info-hubs',
  infoHubSections: '/api/info-hub-sections',
  infoHubResources: '/api/info-hub-section-resources',
  infoHubAttachment: 'api/attachments/info-hub',
};

export const apiResourcesV1 = {
  signIn: `/api/v1/auth/login`,
  signOut: `/api/v1/auth/logout`,
  refreshToken: `/api/v1/auth/refresh_access_token`,
  forgotPassword: `/api/v1/auth/forgot_password`,
  changePassword: `/api/v1/auth/change_password`,
  registration: `/api/v1/auth/register`,
  settings: `/api/v1/settings`,
  injectAssets: `/api/v1/settings/inject-assets`,
  media: `/api/v1/media`,
  profile: `/api/v1/auth/profile`,
  errors: `/api/v1/settings/translations`,
  companies: `/api/v1/companies`,
  users: `/api/v1/users`,
  batch: `/api/v1/users/batch_create`,
  batchDelete: `/api/v1/users/batch_delete`,
  batchInvite: `/api/v1/users/batch_invite`,
  batchReactivate: `/api/v1/users/batch_reactivate`,
  batchBan: `/api/v1/users/batch_ban`,
  batchUnban: `/api/v1/users/batch_unban`,
  sessions: `/api/v1/sessions`,
  templates: `/api/v1/settings/email_templates`,
  resetPassword: `/api/v1/auth/reset_password`,
  changeRole: `/api/v1/auth/change-role`,
  infoHub: `/api/v1/info_hubs`,
  infoHubSections: `/api/v1/info_hub_sections`,
  infoHubResources: `/api/v1/info_hub_section_resources`,
  infoHubAttachment: `/api/v1/attachments/info_hub`,
  sendTwoFactorCode: `/api/v1/auth/send-two-factor-code`,
  participantSessions: `/api/v1/participants/sessions`,
  aiChatHistory: `/api/v1/ai/chat/history`,
  discovery: `/api/v1/auth/discovery`,
  ssoExchange: `/api/v1/auth/sso/exchange`,
  accountSessions: `/api/v1/auth/sessions`,
};
